import companies from './sections/companies';
import cta from './sections/cta';
import hero from './sections/hero';

const translations = {
    page: {
        metaTitle: 'Mindteachers',
        metaDescription: 'Znajdziesz tu wszystkie firmy do rozwoju mentalnego',
    },
    sections: {
        hero,
        companies,
        cta,
    },
};

export default translations;
